import React from 'react';
import Button from '../UI/button';
import ThSearchForm from '../forms/th-search-form';
import SvgIcon from '../SVG/svg';

interface TripsNavBarProps {
  onAddTripStateChange: (state: boolean) => void;
  onSortByStateChange: (state: boolean) => void;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onSearchSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

function TripsNavBar({
  onAddTripStateChange,
  onSortByStateChange,
  searchQuery,
  onSearchChange,
  onSearchSubmit
}: TripsNavBarProps) {
  const handleAddTrip = () => {
    onAddTripStateChange(true);
  };

  const handleSortBy = () => {
    onSortByStateChange(true);
  };

  return (
    <div className='trips-toolbar my-trips-toolbar'>
      <div className='top-navbar-page my-trips-toolbar-layout'>
        {/* Search bar */}
        <div className='trips-toolbar-search-row'>
          <ThSearchForm
            handleSubmit={onSearchSubmit}
            value={searchQuery}
            onChange={onSearchChange}
            placeholder='Search my trips...'
            fullWidth={true}
          />
        </div>

        {/* Title — hidden on mobile, centred on desktop */}
        <div className='trips-toolbar-title'>
          <h2 className='text-dark m-0'>My Trips</h2>
        </div>

        {/* Sort button — col 3 on desktop, shares row with search on mobile */}
        <div className='trips-toolbar-sort-btn'>
          <Button
            variant='transparent'
            width={50}
            height={50}
            onClick={handleSortBy}
          >
            <SvgIcon type='sort' />
          </Button>
        </div>

        {/* Add Trip — row 2 on mobile, combined with sort on desktop */}
        <div className='trips-toolbar-add-trip-row'>
          <Button
            size='md'
            onClick={handleAddTrip}
            width={167}
          >
            Add Trip
          </Button>
        </div>
      </div>
    </div>
  );
}
export default TripsNavBar;
